import { render, staticRenderFns } from "./HeaderBurger.vue?vue&type=template&id=5ccb6d66&scoped=true"
import script from "./HeaderBurger.vue?vue&type=script&lang=js"
export * from "./HeaderBurger.vue?vue&type=script&lang=js"
import style0 from "./HeaderBurger.vue?vue&type=style&index=0&id=5ccb6d66&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ccb6d66",
  null
  
)

export default component.exports